// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const BindPropertyResidents = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        residents: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        bindPropertyResidentsHandler: function(property_id) {

            try {

                this.$bind('residents', propertiesModel.doc(property_id).collection('residents'))
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Bind to the Property Residents from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Residents',
                        uid: 'V9bmKkJ1LO6FykN5wxbg',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Bind to a Property Resident from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Residents',
                    uid: 'PbfqCWMU4dURMsPxj9Qg',
                    error: e
                });

            }

        }

    }

}